module.exports = __webpack_public_path__ + "img/portraits_09_H.6b9da7a8.webp";